(function () {
  "use strict";

  mfCourseActions.$inject = ['$parse'];
  angular
    .module('trainerWebApp.directives')
    .directive('mfCourseActions', mfCourseActions);

  function mfCourseActions($parse) {

    return function ($scope, elem, attrs) {
      var overPopup = false;
      var actionFunction = $parse(attrs['mfCourseActions']);
      var searchTooltip = attrs['mfSearchTooltip'] || '';
      var navigateTooltip = attrs['mfNavigateTooltip'] || '';
      var actionsToShow = attrs['mfActionsToShow'] || 'search navigate';
      var eventAttached = false;

      var contentHtml = '';
      if (~actionsToShow.indexOf('search')) {
        contentHtml = contentHtml + '<a class="search-anchor" style="text-decoration: none;" title="' + searchTooltip + '"><i class="icon-search search-anchor"></i></a>';
      }
      if (~actionsToShow.indexOf('navigate')) {
        if (contentHtml.length > 0) contentHtml = contentHtml + '&nbsp;&nbsp;&nbsp;';
        contentHtml = contentHtml + '<a class="external-anchor" title="' + navigateTooltip + '" style="text-decoration: none;"><i class="icon-external-link"></i></a>';
      }

      var scopeActionFunction = function (args) {
        $scope.$apply(function () {
          actionFunction($scope, {$actionEvent: args});
        });
      };

      function onSearchClick(e) {
        $('[mf-course-actions]').popover('hide');
        scopeActionFunction({action: 'search'});
      }

      function onExternalLinkClick(e) {
        $('[mf-course-actions]').popover('hide');
        scopeActionFunction({action: 'external'});
      }

      elem.popover({
        trigger: 'manual',
        placement: 'right',
        html: true,
        container: 'body',
        content: contentHtml,
        template: '<div class="popover"><div class="arrow"></div><div class="popover-content"></div></div>'
      }).mouseover(function (e) {
        overPopup = true;

        var $popover = $(this);

        setTimeout(function () {
          $('[mf-course-actions]').not($popover).popover('hide');
          $popover.popover('show');

          if (!eventAttached) {
            var searchAnchor = $popover.data('popover').tip().find('.search-anchor');
            searchAnchor.on("click", onSearchClick);

            var externalAnchor = $popover.data('popover').tip().find('.external-anchor');
            externalAnchor.on("click", onExternalLinkClick);
          }
        }, 200);

        $popover.data('popover').tip().mouseenter(function () {
          overPopup = true;
        }).mouseleave(function () {

          overPopup = false;
          setTimeout(function () {
            if (overPopup || !$popover) {
              return;
            }
            $popover.popover('hide');
          }, 200);
        });
      }).mouseout(function (e) {
        overPopup = false;
        var $popover = $(this);
        setTimeout(function () {
          if (overPopup) {
            return;
          }
          $popover.popover('hide');
        }, 200);
      });
    }
  }

})();
